import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from '@mui/material/IconButton';
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../../../redux/features/auth/authSlice";
import ButtonManager from "../../../../shared/components/Button/ButtonManager";
import { LegalStatusService } from "../service/LegalStatusService";
//import "./LegalStatusListing.css";

const columns = [
  { field: "id", headerName: "Id", hideable: true, flex: 1, headerClassName: "researchColmun", headerAlign: "center", align: "left", },
  { field: "description", headerName: "Description", flex: 1, headerClassName: "researchColmun", headerAlign: "center", align: "center", },
  { field: "deleted", headerName: "Actif", flex: 1, headerClassName: "researchColmun", headerAlign: "center", align: "center", 
      renderCell: (data) => (data.value === false) ? <DoneIcon color="success" /> : <CloseIcon color="warning" /> 
  },
];

const forms = [
  { name: "description", label: "Description" },
  { name: "deleted", label: "Supprimé", type: "checkbox" },
];

const LegalStatusListing = () => {
  const dispatch = useDispatch();

  const pageSize = 10;
  const [rows, setRows] = useState([]);
  const [select, setSelect] = useState(null);

  const loadData = () => {
    return LegalStatusService.getLegalStatus(-1, 0)
      .then((response) => {
        const data = response.data.content.sort((legalStatus1, legalStatus2) =>
          legalStatus1.description.localeCompare(legalStatus2.description)
        );
        setRows(
          data.map((row) => {
            const { legalStatusId, ...rest } = row;
            return { id: legalStatusId, ...rest };
          })
        );
        let selected = data.filter((legalStatus) => legalStatus.legalStatusId === select.legalStatusId);
        setSelect(selected.length ? selected[0] : null);
      })
      .catch((err) => {
        if (err?.statusCode === 403 || err?.statusCode === 401 
          || err?.response?.status === 403 || err?.response?.status === 401
        ) {
            dispatch(logout());
        }
      });
  };

  useEffect(() => { loadData() }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', justifyContent: 'center', width: '100%' }}>
      <h1 style={{ fontFamily: 'backToSchool', fontSize: '65px', color: '#bb0000', marginTop: '4%' }}>Statut légal</h1>

      <div style={{ position: 'absolute', top: 23, left: 270 }}>
        <Link to="/SettingsSelect">
          <IconButton color='primary'>
            <ArrowBackIosNewIcon />
          </IconButton>
        </Link>
      </div>
      <div className="event-container display-relative" style={{ marginTop: '5%' }}>
        <ButtonManager
          isContained={true}
          title={"statut légal"}
          id={select?.legalStatusId}
          selected={select}
          align={"center"}
          forms={forms}
          createFunction={LegalStatusService.createLegalStatus}
          updateFunction={LegalStatusService.updateLegalStatus}
          deleteFunction={LegalStatusService.deleteLegalStatus}
          requiredFields={["description"]}
          requiredFieldLabel={["Description"]}
          refresh={loadData}
        />

        <div className="EventDataGrid">
          <DataGrid
            rows={rows}
            columns={columns}
            autoPageSize={true}
            showCellRightBorder
            rowsPerPageOptions={[pageSize]}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRowData = rows.filter((row) =>
                selectedIDs.has(row?.id?.toString())
              );
              if (selectedRowData.length) {
                const { id, ...rest } = selectedRowData[0];
                setSelect({ legalStatusId: id, ...rest });
              } else {
                setSelect(null);
              }
            }}
            columnVisibilityModel={{
              id: false,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LegalStatusListing;
